<template>
  <view class="act004-quiz-question">
    <view class="act004-quiz-question__title">{{ questionTitle }}</view>
    <view v-if="isTextType" class="act004-quiz-question__text">
      <input
        class="act004-quiz-question__input"
        :value="textValue"
        placeholder="请输入答案"
        @input="onTextInput"
      />
    </view>
    <view v-else class="act004-quiz-question__options">
      <view
        v-for="(item, oi) in optionList"
        :key="oi"
        class="act004-quiz-question__option"
        :class="{ 'is-selected': isSelectedByIndex(oi) }"
        :data-index="oi"
        @tap="onToggleOptionByIndex"
      >
        <text>{{ item.label }}</text>
      </view>
    </view>
  </view>
</template>

<script>
export default {
  name: 'Act004QuizQuestion',
  props: {
    question: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      selectedIds: [],
      textValue: ''
    }
  },
  computed: {
    questionTitle() {
      const q = this.question
      return q && q.title ? String(q.title) : ''
    },
    isTextType() {
      const t = this.question && this.question.questionType
      return String(t || '').toUpperCase() === 'TEXT'
    },
    optionList() {
      const q = this.question
      const list = q && Array.isArray(q.options) ? q.options : []
      return list.map((row) => ({
        optionId: row && row.optionId != null ? row.optionId : null,
        label: row && row.label != null ? String(row.label) : ''
      }))
    },
    questionTypeUpper() {
      const t = this.question && this.question.questionType
      return String(t || 'SINGLE').toUpperCase()
    }
  },
  watch: {
    question: {
      immediate: true,
      handler() {
        this.selectedIds = []
        this.textValue = ''
      }
    }
  },
  methods: {
    isSelectedByIndex(oi) {
      const item = this.optionList[oi]
      if (!item || item.optionId == null) return false
      return this.selectedIds.some((id) => String(id) === String(item.optionId))
    },
    onToggleOptionByIndex(e) {
      let oi = -1
      if (e && e.currentTarget && e.currentTarget.dataset) {
        const raw = e.currentTarget.dataset.index
        oi = parseInt(raw, 10)
      }
      if (!Number.isFinite(oi) || oi < 0) return
      const item = this.optionList[oi]
      if (!item || item.optionId == null) return
      const id = item.optionId
      const type = this.questionTypeUpper
      if (type === 'MULTI') {
        const idx = this.selectedIds.findIndex((x) => String(x) === String(id))
        if (idx >= 0) {
          this.selectedIds.splice(idx, 1)
        } else {
          this.selectedIds.push(id)
        }
      } else {
        this.selectedIds = [id]
      }
      this.emitPayload()
    },
    onTextInput(e) {
      this.textValue = (e && e.detail && e.detail.value) || ''
      this.emitPayload()
    },
    emitPayload() {
      const type = this.questionTypeUpper
      let payload = null
      if (type === 'TEXT') {
        payload = { text: this.textValue }
      } else if (type === 'MULTI') {
        payload = { optionIds: this.selectedIds.slice() }
      } else {
        payload = { optionId: this.selectedIds[0] != null ? this.selectedIds[0] : null }
      }
      this.$emit('change', payload)
    },
    getAnswerPayload() {
      const type = this.questionTypeUpper
      if (type === 'TEXT') {
        return { text: this.textValue }
      }
      if (type === 'MULTI') {
        return { optionIds: this.selectedIds.slice() }
      }
      return { optionId: this.selectedIds[0] != null ? this.selectedIds[0] : null }
    }
  }
}
</script>

<style scoped>
.act004-quiz-question__title {
  font-size: 30rpx;
  color: #333;
  line-height: 1.5;
  margin-bottom: 24rpx;
}
.act004-quiz-question__input {
  border: 1px solid #ddd;
  border-radius: 12rpx;
  padding: 20rpx;
  font-size: 28rpx;
}
.act004-quiz-question__option {
  padding: 24rpx;
  margin-bottom: 16rpx;
  border-radius: 12rpx;
  background: #f5f5f5;
  font-size: 28rpx;
}
.act004-quiz-question__option.is-selected {
  background: #e8f4ff;
  border: 1px solid #409eff;
}
</style>
